import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "@/App";
import { ErrorBoundary } from "@/components/error-boundary";
import "@/index.css";

/**
 * Recuperação de chunks obsoletos após um deploy.
 *
 * O Vite gera nomes de ficheiro com hash. Se o utilizador tem a página aberta
 * durante um deploy e depois navega para uma rota `lazy()`, o browser pede um
 * chunk que já não existe e a navegação falha em silêncio.
 *
 * Aqui recarregamos UMA vez por sessão (a guarda em sessionStorage evita o
 * ciclo infinito se a falha for outra coisa qualquer).
 */
window.addEventListener("vite:preloadError", () => {
  if (sessionStorage.getItem("tgt:recarga-chunk")) return;
  sessionStorage.setItem("tgt:recarga-chunk", "1");
  window.location.reload();
});

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </StrictMode>,
);
